import { Stack } from '@mui/material';
import { type FlowOcrBoundingBoxMode, type FlowOcrDetailLevel } from 'flow-schema';

import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField.tsx';
import { BlockSelectField } from '../../../ConfigFields/SelectField.tsx';

interface LegacyOcrFieldsProps {
  detailLevelSupportsBoundingBoxes: boolean;
  detailLevelOptions: { label: string; value: FlowOcrDetailLevel }[];
  boundingBoxModeOptions: { label: string; value: FlowOcrBoundingBoxMode }[];
}

export function LegacyOcrFields(props: LegacyOcrFieldsProps) {
  const { detailLevelSupportsBoundingBoxes, detailLevelOptions, boundingBoxModeOptions } = props;

  return (
    <Stack spacing={2}>
      <BlockSelectField
        options={detailLevelOptions}
        label="Level of detail for OCR metadata"
        fieldName="config.detailLevel"
        helperText='Set to "None" to disable metadata.'
      />
      {detailLevelSupportsBoundingBoxes && (
        <BlockRadioGroupField
          options={boundingBoxModeOptions}
          label="Bounding box mode"
          fieldName="config.boundingBoxMode"
          helperText="When Enabled, bounding box information will be provided to the selected level of detail for OCR metadata."
          row
        />
      )}
    </Stack>
  );
}
